// function loadRecaptchaSatisfaction(form) {
//     grecaptcha.execute(recaptchaKey,
//         { action: 'satisfaction' }).then(function (token) {
//         var recaptchaResponse = document.getElementById('satisfaction_recaptcha');
//         recaptchaResponse.value = token;
//
//         $.post('/satisfaction/send', form.serializeArray(), function(data) {
//             $('#satisfaction-wrapper').html(data.html);
//             setTimeout(function () {
//                 initFormSatisfaction();
//             }, 250);
//             if (data.result) {
//                 MicroModal.show('satisfaction-form-modal');
//                 window.dataLayer =  window.dataLayer || [];
// //                        dataLayer.push({
// //                            'event': 'submit',
// //                            'context_submitted': 'satisfaction'
// //                        });
// //                        fbq_trackCustom('submit__satisfaction');
//             }
//         });
//     });
// }
//
// var submitHandlerSatisfaction = function(e) {
//     e.preventDefault();
//     e.target.removeEventListener('submit', submitHandlerSatisfaction, false);
//
//     document.getElementById('satisfaction-form-submit').classList.add('d-none');
//     document.getElementById('satisfaction-form-loader').classList.remove('d-none');
//
//     var form = $(this);
//     console.log(form);
//     console.log(form.serializeArray());
//     loadRecaptchaSatisfaction(form);
// };
//
// function initFormSatisfaction() {
//     console.log(document.getElementById('satisfaction-form'));
//     document.getElementById('satisfaction-form').addEventListener("submit", submitHandlerSatisfaction);
// }
// initFormSatisfaction();